





































































































import { AppModule } from '@app/componentlib/src/store/modules/app'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component<JobResultSkeleton>({

})

export default class JobResultSkeleton extends Vue {
  /**
   * Props variables
   */

  /**
   * Component state variables
   */
  iterateList = [1, 2, 3, 4]
  activePosting: number = 0

  /**
   * Lifecycle
   */


  /**
   * Getters
   */

   get isMobile (): boolean {
    return AppModule.isMobile
   }


  /**
   * Methods
   */

}
